import React from "react";
import "./PageStyles.css";

function Terms() {
  return (
    <div className="page-container">
      <h1>Terms & Conditions</h1>

      <p>
        <strong>Effective Date: May 2026</strong>
      </p>

      <p>
        Welcome to Alpha APK Store™. By accessing and using
        https://www.alphaapkstore.com, you agree to comply with these Terms
        and Conditions. If you do not agree with any part of these terms,
        please discontinue use of the website.
      </p>

      <h2>Website Purpose</h2>

      <p>
        Alpha APK Store is an Android APK information and download platform
        designed to help users discover Android applications, view APK details,
        check compatibility, and access app-related information.
      </p>

      <p>
        The website is intended for lawful personal use only.
      </p>

      <h2>Eligibility</h2>

      <p>
        By using this website, you confirm that you are legally permitted to
        access online content and comply with local laws regarding Android app
        downloads and software usage.
      </p>

      <h2>User Accounts and Google Login</h2>

      <p>
        Alpha APK Store may offer optional Google login and account-based
        features through secure authentication systems.
      </p>

      <p>
        Users are responsible for maintaining account security and must not
        attempt unauthorized access to restricted administrative areas.
      </p>

      <h2>APK Usage</h2>

      <p>
        APK files and app-related content available through Alpha APK Store are
        intended for personal Android use only.
      </p>

      <p>
        Users are responsible for checking Android compatibility, storage
        requirements, and app permissions before installation.
      </p>

      <p>
        APK files are supported only on Android devices. iPhone, iPad, and
        iOS devices cannot install APK files.
      </p>

      <h2>Prohibited Activities</h2>

      <p>Users must not:</p>

      <ul>
        <li>Attempt unauthorized access to admin systems</li>
        <li>Copy or scrape website content at scale</li>
        <li>Disrupt website performance or security</li>
        <li>Misuse authentication features</li>
        <li>Use the platform for unlawful purposes</li>
      </ul>

      <h2>Intellectual Property</h2>

      <p>
        All third-party app names, trademarks, logos, and brand identities
        belong to their respective owners.
      </p>

      <p>
        Alpha APK Store does not claim ownership of third-party Android
        applications listed on this website.
      </p>

      <p>
        Alpha APK Store branding, website design, custom features, structure,
        layouts, written content, SEO architecture, and platform systems are
        protected intellectual property of the website owner.
      </p>

      <p>
        <strong>Website Owner: KARANDEEP SINGH SANDHU</strong>
      </p>

      <h2>Ownership Rights</h2>

      <p>
        All original website systems, custom platform features, branding,
        design implementations, and Alpha APK Store platform rights are fully
        owned and controlled by the owner.
      </p>

      <p>
        Unauthorized reproduction, duplication, redistribution, or copying of
        Alpha APK Store platform elements is prohibited.
      </p>

      <h2>Third-Party Services</h2>

      <p>
        This website may use third-party services including Google Analytics,
        Google Search Console, Google Login, Google AdSense, and Supabase.

        Disclaimer that you don't own apps, users verify before installing, no liability
      </p>

      <p>
        These services operate under their own terms and privacy policies.
      </p>

      <h2>Limitation of Liability</h2>

      <p>
        Alpha APK Store is provided on an "as available" basis.
      </p>

      <p>
        We are not responsible for:
      </p>

      <ul>
        <li>Device issues caused by third-party APK installation</li>
        <li>Compatibility problems</li>
        <li>Data loss</li>
        <li>Third-party software behavior</li>
        <li>External website content</li>
      </ul>

      <h2>DMCA & Copyright</h2>

      <p>
        If you believe any content infringes copyright, please contact us for
        prompt review and action.
      </p>

      <h2>Updates to Terms</h2>

      <p>
        Alpha APK Store reserves the right to update these Terms and Conditions
        at any time without prior notice.
      </p>

      <h2>Contact</h2>

      <p>
        For legal inquiries, support, or policy-related questions:
      </p>

      <p>
        <strong>alphaapkstore@gmail.com</strong>
      </p>

      <p>
        <strong>Owner: KARANDEEP SINGH SANDHU</strong>
      </p>
    </div>
  );
}

export default Terms;